import { ContactsService, IContact } from '../../../services/contacts.service';
import { EmployeesService, IEmployee } from '../../../services';
import { AuthUserService, IAuthUser } from '../../../authsettings/services/authusers.service';
import * as _ from "lodash";

class UserAccountController implements ng.IComponentController {

    public userAccount: IAuthUser;
    public employee?: IEmployee;
    public contact?: IContact;

    public password: string;
    public newUser: boolean;

    constructor(
        private AuthUserService: AuthUserService,
        private EmployeesService: EmployeesService,
        private ContactsService: ContactsService,
        private $state: ng.ui.IStateService,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    private checkUserType = (): string => {
        if (this.contact) return 'contact';
        if (this.employee) return 'employee';
        else return undefined;
    }

    public $onInit = () => {
        this.newUser = true;
        const userType = this.checkUserType();
        if (this[userType].userId) {
            this.AuthUserService.get(this[userType].userId).then(res => {
                this.userAccount = res;
                this.newUser = false;
            })
        }
    }

    private prepareEmployeeForUser = (employee: IEmployee): IAuthUser => {
        const user: IAuthUser = {
            displayName: employee.displayName,
            roles: ['EMPLOYEE'],
            email: employee.emailPrivate,
            userName: employee.emailPrivate,
            password: this.password,
            claims: { 'employeeId': employee.id },
        }
        return user;
    }

    private prepareContactForUser = (contact: IContact): IAuthUser => {
        const user: IAuthUser = {
            displayName: contact.name,
            roles: ['CUSTOMER'],
            email: contact.emailAddress,
            userName: contact.emailAddress,
            password: this.password,
            claims: { 'contactId': contact.id, 'customerId': contact.accountId },
        }
        return user
    }

    public createUser = (): void => {
        let user = new IAuthUser();
        if (this.employee) {
            let user = this.prepareEmployeeForUser(this.employee);
            this.AuthUserService.post(user).then(result => {
                this.employee.userId = result.id;
                this.employee.userName = this.employee.emailPrivate;
                this.EmployeesService.put(this.employee.id, this.employee).then(
                    result => {
                        this.employee = result;
                        this.$onInit();
                    });

            }).catch((error) => {
                this.AuthUserService.all().then((users) => {
                    var existUser = _.find(users, {userName: user.userName});
                    this.SweetAlert.swal({
                        title: "User already exist!",
                        text: "User with "+ existUser.userName +" do you want to connect this user to this contactperson?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Yes, connect it!",
                        closeOnConfirm: false
                    }, (isConfirm) => {
                        this.employee.userId = existUser.id;
                        this.employee.userName = existUser.userName;
                        this.EmployeesService.put(this.employee.id, this.employee).then(employee => {
                            this.employee = employee;
                            this.$onInit();
                        });
                    });
                });
            })
        }
        if (this.contact) {
            let user = this.prepareContactForUser(this.contact);
            this.AuthUserService.post(user).then(result => {
                this.contact.userId = result.id;
                this.ContactsService.put(this.contact.id, this.contact).then(
                    result => {
                        this.contact = result;
                        this.$onInit();
                    });
            })
        }
    }

    public deleteUser = (): void => {
        if (this.employee) {
            this.AuthUserService.delete(this.employee.userId).then(result => {
                this.employee.userId = undefined;
                this.EmployeesService.put(this.employee.id, this.employee).then(employee => {
                    this.employee = employee;
                    this.$onInit();
                })
            })
        } if (this.contact) {
            this.AuthUserService.delete(this.contact.userId).then(result => {
                this.contact.userId = undefined;
                this.ContactsService.put(this.contact.id, this.contact).then(contact => {
                    this.contact = contact;
                    this.$onInit();
                })
            })
        }
    }
}

export const userAccountComponent = {
    bindings: {
        contact: "<",
        employee: "<"
    },
    controller: UserAccountController,
    template: require('./user-account.html')
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/user-account/user-account.component.ts